import { Unidade } from './Unidade';
import { Fatura } from './fatura';

export class FaturamentoDetalhado {
  unidade: Unidade;
  listaFaturas: Fatura[];
  gerarNota: boolean;
  gerarBoleto: boolean;
  faturaUnidadeFaturante: boolean;
  outrasUnidadeFaturantes: Unidade[];

  constructor(faturamentoDetalhado) {

    this.unidade = new Unidade(faturamentoDetalhado['unidade']) || null;
    this.listaFaturas = (faturamentoDetalhado['listaFaturas'] || []).map(f=>new Fatura(f));
    this.gerarNota = faturamentoDetalhado['gerarNota'] || false;
    this.gerarBoleto = faturamentoDetalhado['gerarBoleto'] || false;
    this.faturaUnidadeFaturante = faturamentoDetalhado['faturaUnidadeFaturante'] || false;
    this.outrasUnidadeFaturantes = (faturamentoDetalhado['outrasUnidadeFaturantes'] || []).map(f=>new Unidade(f));
  }

}
